<template>
    <div class="flex">
        <div class="card card--graphs">
            <div v-if="computeQuota" class="btn-nodropdown quota__btn"><a href="#" class="listbtn" @click.prevent="showInstanceQuotaIncrease()"><i aria-hidden="true" class="fa fa-pencil"></i></a></div>
            <div class="flex">
                <div class="left__side">
                    <h3>Compute usage</h3>
                    <p class="mt-4 mb-2">Number of instances</p>
                    <span v-if="computeQuota">
                        <h4 v-for="(item, key) in computeQuota"><strong><span v-if="item.region !== 'core'">{{ item.region }}</span><span v-else>ams</span>: {{ item.instances.in_use }}</strong></h4>
                    </span>
                    <h4 v-else><strong>loading..</strong></h4>
                    <div class="card__action">
                        <router-link :to="{ name: 'instances' }">Manage your instances</router-link>
                    </div>
                </div>
                <div v-if="computeQuota">
                    <div class="chart__container" v-if="!noUsage.compute">
                        <inUseChart :inUseData="computeQuota" component="compute"  />
                    </div>
                    <div class="chart__container no__data" v-else>
                        <div class="content"><strong>No usage</strong></div>
                    </div>
                </div>
                <div class="chart__container no__data" v-else>
                    <div class="content"><strong>Loading..</strong></div>
                </div>
            </div>
        </div>
        <div class="card card--graphs">
            <div v-if="volumeQuota" class="btn-nodropdown quota__btn"><a href="#" class="listbtn" @click.prevent="showVolumeQuotaIncrease()"><i aria-hidden="true" class="fa fa-pencil"></i></a></div>
            <div class="flex">
                <div class="left__side">
                    <h3>Volume usage</h3>
                    <p class="mt-4 mb-2">Number of volumes</p>
                    <span v-if="volumeQuota">
                        <h4 v-for="(item, key) in volumeQuota"><strong><span v-if="item.region !== 'core'">{{ item.region }}</span><span v-else>ams</span>: {{ item.volumes.in_use }}</strong><small><br>Snapshots {{ item.snapshots.in_use }}</small></h4>
                    </span>
                    <h4 v-else><strong>loading..</strong></h4>
                    <div class="card__action">
                        <router-link :to="{ name: 'volume-store' }">Manage your volumes</router-link>
                    </div>
                </div>
                <div v-if="volumeQuota">
                    <div class="chart__container" v-if="!noUsage.volume">
                        <inUseChart :inUseData="volumeQuota" component="volume"  />
                    </div>
                    <div class="chart__container no__data" v-else>
                        <div class="content"><strong>No usage</strong></div>
                    </div>
                </div>
                <div class="chart__container no__data" v-else>
                    <div class="content"><strong>Loading..</strong></div>
                </div>
            </div>
        </div>
        <div class="card card--graphs">
            <div class="flex">
                <div class="left__side">
                    <h3>Network usage</h3>
                    <p class="mt-4 mb-2">Number of networks</p>
                    <span v-if="networkQuota">
                        <h4 v-for="(item, key) in networkQuota"><strong><span v-if="item.region !== 'core'">{{ item.region }}</span><span v-else>ams</span>: {{ item.network.used }}</strong></h4>
                    </span>
                    <h4 v-else><strong>loading..</strong></h4>
                    <div class="card__action">
                        <router-link :to="{ name: 'networks' }">Manage your networking</router-link>
                    </div>
                </div>
                <div v-if="networkQuota">
                    <div class="chart__container" v-if="!noUsage.network">
                        <inUseChart :inUseData="networkQuota" component="network"  />
                    </div>
                    <div class="chart__container no__data" v-else>
                        <div class="content"><strong>No usage</strong></div>
                    </div>
                </div>
                <div class="chart__container no__data" v-else>
                    <div class="content"><strong>Loading..</strong></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inUseChart from '@/components/charts/f-chart-in-use';

export default {
    data() {
        return {
            noUsage: {
                compute: false,
                volume: false,
                network: false,
            }
        };
    },

    computed: {
        computeQuota() {
            let data = this.$store.state.instance.quota;
            // data =   [ { "id": "1be9f877c0a3422882fc6885daf99dc7", "cores": { "limit": -1, "in_use": 3, "reserved": 0 }, "fixed_ips": { "limit": -1, "in_use": 0, "reserved": 0 }, "floating_ips": { "limit": -1, "in_use": 0, "reserved": 0 }, "injected_file_content_bytes": { "limit": -1, "in_use": 0, "reserved": 0 }, "injected_file_path_bytes": { "limit": -1, "in_use": 0, "reserved": 0 }, "injected_files": { "limit": -1, "in_use": 0, "reserved": 0 }, "instances": { "limit": -1, "in_use": 0, "reserved": 0 }, "key_pairs": { "limit": 100, "in_use": 0, "reserved": 0 }, "metadata_items": { "limit": 128, "in_use": 0, "reserved": 0 }, "ram": { "limit": 151200, "in_use": 5376, "reserved": 0 }, "security_group_rules": { "limit": -1, "in_use": 0, "reserved": 0 }, "security_groups": { "limit": -1, "in_use": 0, "reserved": 0 }, "server_group_members": { "limit": -1, "in_use": 0, "reserved": 0 }, "server_groups": { "limit": -1, "in_use": 0, "reserved": 0 }, "region": "core" }, { "id": "c72aa60edcab4f8fbc286ee9b4a76eec", "cores": { "limit": 20, "in_use": 1, "reserved": 0 }, "fixed_ips": { "limit": -1, "in_use": 0, "reserved": 0 }, "floating_ips": { "limit": -1, "in_use": 0, "reserved": 0 }, "injected_file_content_bytes": { "limit": 10240, "in_use": 0, "reserved": 0 }, "injected_file_path_bytes": { "limit": 255, "in_use": 0, "reserved": 0 }, "injected_files": { "limit": 5, "in_use": 0, "reserved": 0 }, "instances": { "limit": 10, "in_use": 0, "reserved": 0 }, "key_pairs": { "limit": 100, "in_use": 0, "reserved": 0 }, "metadata_items": { "limit": 128, "in_use": 0, "reserved": 0 }, "ram": { "limit": 51200, "in_use": 2048, "reserved": 0 }, "security_group_rules": { "limit": -1, "in_use": 0, "reserved": 0 }, "security_groups": { "limit": -1, "in_use": 0, "reserved": 0 }, "server_group_members": { "limit": 10, "in_use": 0, "reserved": 0 }, "server_groups": { "limit": 10, "in_use": 0, "reserved": 0 }, "region": "fra" } ] 
            if (data && data.length > 0) {
                let total = 0;
                data.forEach(item => {
                    total += item.instances.in_use;
                });
                if (total === 0) {
                    this.noUsage.compute = true;
                }
            }
            return data;
        },

        volumeQuota() {
            let data = this.$store.state.volumev3.quota;
            // let data = [{"volumes":{"limit":-1,"in_use":0,"reserved":0},"per_volume_gigabytes":{"limit":-1,"in_use":0,"reserved":0},"snapshots":{"limit":-1,"in_use":0,"reserved":0},"gigabytes":{"limit":10000,"in_use":0,"reserved":0},"backups":{"limit":10,"in_use":0,"reserved":0},"backup_gigabytes":{"limit":1000,"in_use":0,"reserved":0},"volumes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"snapshots_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-2":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-2":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"groups":{"limit":10,"in_use":0,"reserved":0},"id":"1be9f877c0a3422882fc6885daf99dc7","region":"ams"},{"volumes":{"limit":10,"in_use":0,"reserved":0},"per_volume_gigabytes":{"limit":-1,"in_use":0,"reserved":0},"snapshots":{"limit":10,"in_use":0,"reserved":0},"gigabytes":{"limit":1000,"in_use":0,"reserved":0},"backups":{"limit":10,"in_use":0,"reserved":0},"backup_gigabytes":{"limit":1000,"in_use":0,"reserved":0},"volumes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"volumes_Unlimited":{"limit":-1,"g":0,"reserved":0},"gigabytes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"snapshots_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2":{"limit":-1,"in_use":2,"reserved":0},"gigabytes_tier-2":{"limit":-1,"in_use":30,"reserved":0},"snapshots_tier-2":{"limit":-1,"in_use":0,"reserved":0},"groups":{"limit":10,"in_use":0,"reserved":0},"id":"c72aa60edcab4f8fbc286ee9b4a76eec","region":"fra"}]
            // data = [{"volumes":{"limit":-1,"in_use":18,"reserved":0},"per_volume_gigabytes":{"limit":-1,"in_use":0,"reserved":0},"snapshots":{"limit":-1,"in_use":2,"reserved":0},"gigabytes":{"limit":10000,"in_use":640,"reserved":0},"backups":{"limit":10,"in_use":0,"reserved":0},"backup_gigabytes":{"limit":1000,"in_use":0,"reserved":0},"volumes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"snapshots_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1e":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2":{"limit":-1,"in_use":7,"reserved":0},"gigabytes_tier-2":{"limit":-1,"in_use":170,"reserved":0},"snapshots_tier-2":{"limit":-1,"in_use":1,"reserved":0},"volumes_tier-1":{"limit":-1,"in_use":11,"reserved":0},"gigabytes_tier-1":{"limit":-1,"in_use":440,"reserved":0},"snapshots_tier-1":{"limit":-1,"in_use":1,"reserved":0},"volumes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"groups":{"limit":10,"in_use":0,"reserved":0},"id":"1be9f877c0a3422882fc6885daf99dc7","region":"ams"},{"volumes":{"limit":10,"in_use":2,"reserved":0},"per_volume_gigabytes":{"limit":-1,"in_use":0,"reserved":0},"snapshots":{"limit":10,"in_use":1,"reserved":0},"gigabytes":{"limit":1000,"in_use":30,"reserved":0},"backups":{"limit":10,"in_use":0,"reserved":0},"backup_gigabytes":{"limit":1000,"in_use":0,"reserved":0},"volumes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-1m":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"snapshots_tier-2m":{"limit":-1,"in_use":0,"reserved":0},"volumes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"gigabytes_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"snapshots_Unlimited":{"limit":-1,"in_use":0,"reserved":0},"volumes_tier-2":{"limit":-1,"in_use":2,"reserved":0},"gigabytes_tier-2":{"limit":-1,"in_use":30,"reserved":0},"snapshots_tier-2":{"limit":-1,"in_use":0,"reserved":0},"groups":{"limit":10,"in_use":0,"reserved":0},"id":"c72aa60edcab4f8fbc286ee9b4a76eec","region":"fra"}]
            if (data && data.length > 0) {
                let total = 0;
                data.forEach(item => {
                    total += item.volumes.in_use;
                });
                if (total === 0) {
                    this.noUsage.volume = true;
                }
            }
            return data;
        },

        networkQuota() {
            let data = this.$store.state.network.quota;
            // console.log('network quota' , data)
            // let data = [{"network": {"limit": 100, "used": 5, "reserved": 0}, "subnet": {"limit": 100, "used": 3, "reserved": 0}, "subnetpool": {"limit": -1, "used": 0, "reserved": 0}, "port": {"limit": 500, "used": 13, "reserved": 0}, "router": {"limit": 100, "used": 4, "reserved": 0}, "floatingip": {"limit": 50, "used": 1, "reserved": 0}, "rbac_policy": {"limit": 10, "used": 0, "reserved": 0}, "security_group": {"limit": -1, "used": 4, "reserved": 0}, "security_group_rule": {"limit": -1, "used": 14, "reserved": 0},"region": "ams"},{"network": {"limit": 100, "used": 1, "reserved": 0}, "subnet": {"limit": 100, "used": 4, "reserved": 0}, "subnetpool": {"limit": -1, "used": 0, "reserved": 0}, "port": {"limit": 500, "used": 9, "reserved": 0}, "router": {"limit": 100, "used": 6, "reserved": 0}, "floatingip": {"limit": 50, "used": 3, "reserved": 0}, "rbac_policy": {"limit": 10, "used": 0, "reserved": 0}, "security_group": {"limit": -1, "used": 2, "reserved": 0}, "security_group_rule": {"limit": -1, "used": 12, "reserved": 0},"region": "fra"}]
            // data = [{"network": {"limit": 100, "used": 0, "reserved": 0}, "subnet": {"limit": 100, "used": 0, "reserved": 0}, "subnetpool": {"limit": -1, "used": 0, "reserved": 0}, "port": {"limit": 500, "used": 0, "reserved": 0}, "router": {"limit": 100, "used": 0, "reserved": 0}, "floatingip": {"limit": 50, "used": 0, "reserved": 0}, "rbac_policy": {"limit": 10, "used": 0, "reserved": 0}, "security_group": {"limit": -1, "used": 0, "reserved": 0}, "security_group_rule": {"limit": -1, "used": 0, "reserved": 0},"region": "ams"},{"network": {"limit": 100, "used": 0, "reserved": 0}, "subnet": {"limit": 100, "used": 0, "reserved": 0}, "subnetpool": {"limit": -1, "used": 0, "reserved": 0}, "port": {"limit": 500, "used": 0, "reserved": 0}, "router": {"limit": 100, "used": 0, "reserved": 0}, "floatingip": {"limit": 50, "used": 0, "reserved": 0}, "rbac_policy": {"limit": 10, "used": 0, "reserved": 0}, "security_group": {"limit": -1, "used": 0, "reserved": 0}, "security_group_rule": {"limit": -1, "used": 0, "reserved": 0},"region": "fra"}]
            if (data && data.length > 0) {
                let total = 0;
                data.forEach(item => {
                    total += item.network.used;
                    total += item.subnet.used;
                    total += item.port.used;
                    total += item.port.used;
                });
                if (total === 0) {
                    this.noUsage.network = true;
                }
            }
            return data;
        },
    },

    methods: {
        showInstanceQuotaIncrease() {
            this.$store.commit('volumev3/UPDATE_KEY');
            this.$store.commit('instance/ACTIVE_QUOTA', true);
            this.$store.commit('volumev3/ACTIVE_QUOTA', false);
            this.osModal('SHOW_FORM_QUOTA_INCREASE');
        },

        showVolumeQuotaIncrease() {
            this.$store.commit('volumev3/UPDATE_KEY');
            this.$store.commit('instance/ACTIVE_QUOTA', false);
            this.$store.commit('volumev3/ACTIVE_QUOTA', true);
            this.osModal('SHOW_FORM_QUOTA_INCREASE');
        },
    },

    created() {
        this.fetchQuotas();
    },

    components: {
        inUseChart,
    },
}
</script>
<style scoped="scoped">

.card--graphs {
    flex-basis: 100%;
    min-height: 310px;
    overflow: hidden;
}
.card--graphs > .flex {
    border-left: 2px solid #25b3b8;
    padding-left: 20px;
}
.chart__container {
    position: relative;
    max-width: 250px;
}
.left__side {
    flex-basis: 50%;
    position: relative;
}
.card__action {
    position: absolute;
    bottom: 0;
    border-top: 1px solid #dae1e7;
    width: 100%;
    padding: 5px 0 0 0;
}
.left__side small {
    font-size: 10px;
    color: #60676a;
}
.left__side h4 {
    line-height: 0.8;
    margin: 10px 0 20px 0
}
.no__data {
    height: 250px;
    width: 250px;
    background: #003f5c;
    background: linear-gradient(180deg, rgba(0,63,92,1) 0%, #665191 100%);
    border-radius: 50%;
    align-items: center;
    display: flex;
    justify-content: center;
    opacity: .5;
}
.no__data .content {
    border-radius: 50%;
    background: #fff;
    height: 125px;
    width: 125px;
    vertical-align: middle;
    align-items: center;
    display: flex;
    justify-content: center;
}
.quota__btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>